module.exports = __webpack_public_path__ + "mainassets/img/anim_04_570x570.e94f0b7a.webp";